import React from 'react'
import {
    getServiceAreaConfig,
    setServiceAreaConfig,
} from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import { Switch, Button } from '@material-ui/core/index'
import { strings } from '../../../localization/strings'
import routes from '../../router/routes'
import Grid from '@material-ui/core/Grid/Grid'
import DetailsIcon from '@material-ui/icons/NewReleases'

const style = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        textAlign: 'center',
        margin: '20px auto',
        fontWeight: 400,
        fontSize: '1.6428571428571428rem',
    },
    table: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        opacity: 0.87,
        fontFamily: 'neutra',
        fontSize: '1.1428571428571428rem',
        width: '90%',
        maxWidth: 600,
        minWidth: 250,
        margin: '20px auto',
        marginBottom: 10,
    },
    titleRow: {
        fontWeight: 'bolder',
        fontSize: '1.3rem',
        borderBottom: '#f7b500 1px solid',
        marginBottom: 10,
    },
    methodRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 10,
    },
    button: {
        margin: '20px auto',
    },
}

class Component extends React.Component {
    state = {
        oldConfig: null,
        serviceAreaConfigList: null,
        loader: true,
    }

    componentDidMount() {
        this.getConfig()
    }

    getConfig = () => {
        this.setState({ loader: true })
        getServiceAreaConfig()
            .then((x) =>
                this.setState({ serviceAreaConfigList: x, oldConfig: x })
            )
            .catch((x) =>
                window.showDialog(x, () =>
                    this.props.history.push(routes.orders.path)
                )
            )
            .finally(() => this.setState({ loader: false }))
    }

    setConfig = () => {
        this.setState({ loader: true })
        setServiceAreaConfig(this.state.serviceAreaConfigList)
            .then(() =>
                window.showDialog(
                    {
                        title: strings.saveSuccessTitle,
                        message: strings.saveSuccessDialog,
                    },
                    () => this.props.history.push(routes.orders.path)
                )
            )
            .catch(() =>
                window.showDialog({
                    title: strings.saveErrorTitle,
                    message: strings.saveErrorDialog,
                })
            )
            .finally(() => this.setState({ loader: false }))
    }

    setShippingMethodValue = (serviceAreaConfig, shippingMethodId) => {
        var list = this.state.serviceAreaConfigList.map((config) =>
            config.serviceAreaId !== serviceAreaConfig.serviceAreaId
                ? config
                : {
                      ...config,
                      shippingMethodConfigurations:
                          config.shippingMethodConfigurations.map((method) =>
                              method.shippingMethodId !== shippingMethodId
                                  ? method
                                  : {
                                        ...method,
                                        enabled: !method.enabled,
                                    }
                          ),
                  }
        )
        this.setState({ serviceAreaConfigList: list })
    }

    hasConfigChange = () => {
        const { serviceAreaConfigList, oldConfig } = this.state
        var hasChange = false
        serviceAreaConfigList.forEach((newConfig) =>
            newConfig.shippingMethodConfigurations.forEach((method) => {
                var oldEnabled = oldConfig
                    .find((x) => x.serviceAreaId === newConfig.serviceAreaId)
                    .shippingMethodConfigurations.find(
                        (x) => x.shippingMethodId === method.shippingMethodId
                    ).enabled
                if (oldEnabled !== method.enabled) hasChange = true
            })
        )
        return hasChange
    }

    render() {
        if (this.state.loader) return <Loader />
        const { serviceAreaConfigList } = this.state

        return (
            <div style={style.container}>
                <div style={style.table}>
                    {serviceAreaConfigList.length === 0 ? (
                        <div
                            className="alert alert-warning"
                            role="alert"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            <Grid container>
                                <Grid item xs={2} sm={2}>
                                    <i>
                                        <DetailsIcon />
                                    </i>
                                </Grid>
                                <Grid item xs={10} sm={10}>
                                    {strings.serviceAreaNoMethodsAvailable}
                                </Grid>
                            </Grid>
                        </div>
                    ) : null}

                    {serviceAreaConfigList.map((config) => (
                        <div key={config.serviceAreaId}>
                            <div style={style.titleRow}>
                                {config.serviceAreaName}
                            </div>

                            {config.shippingMethodConfigurations.map(
                                (method) => (
                                    <div
                                        style={style.methodRow}
                                        key={config.shippingMethodConfigurations.indexOf(method)}
                                    >
                                        <div>{method.shippingMethodName}</div>
                                        <Switch
                                            checked={method.enabled}
                                            onChange={() =>
                                                this.setShippingMethodValue(
                                                    config,
                                                    method.shippingMethodId
                                                )
                                            }
                                            color="primary"
                                            inputProps={{
                                                'aria-label':
                                                    'primary checkbox',
                                            }}
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    ))}
                </div>

                {serviceAreaConfigList.length === 0 ? null : (
                    <Button
                        style={style.button}
                        label={strings.configSaveButton}
                        variant="contained"
                        color="primary"
                        onClick={this.setConfig}
                        disabled={!this.hasConfigChange()}
                    >
                        {strings.configSaveButton}
                    </Button>
                )}
            </div>
        )
    }
}

export default Component
